import { Ok, Result } from 'ts-res';
import { KameleoonData } from 'src/kameleoonData/types';
import { KameleoonError } from 'src/kameleoonError';
import { EvaluationDataType } from 'src/targeting/types';
import { ConditionDataType, ICondition } from './types';

export class Conversion implements ICondition {
  private conditionValue?: number | null;

  constructor({ goalId }: ConditionDataType) {
    this.conditionValue = goalId;
  }

  public evaluate({
    targetingData,
  }: EvaluationDataType): Result<boolean, KameleoonError> {
    const conversionData = targetingData?.[KameleoonData.Conversion];

    if (!this.conditionValue) {
      return Ok(false);
    }

    if (conversionData) {
      if (Object.keys(conversionData).length && this.conditionValue === -1) {
        return Ok(true);
      }

      const conversions = Object.values(conversionData);

      return Ok(
        conversions.some((conversion) => {
          if (!conversion) {
            return false;
          }

          return conversion.goalId === this.conditionValue;
        }),
      );
    }

    return Ok(false);
  }
}
